import React from 'react';

import { Table } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import './style.scss';

interface Product {
    name: string;
    quantity: number;
    _id?: string;
}

interface ProductsModalProps {
    isVisible: boolean;
    onClose: () => void;
    products: Product[];
    customerName?: string;
}

const ProductsModal: React.FC<ProductsModalProps> = ({ isVisible, onClose, products, customerName }) => {
    const columns = [
        {
            title: 'Product Name',
            dataIndex: 'name',
            key: 'name',
            width: '60%',
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            width: '40%',
            align: 'center' as const,
        },
    ];

    if (!isVisible) return null;

    return (
        <div className='products-modal-overlay' onClick={onClose}>
            <div className='products-modal-container' onClick={(e) => e.stopPropagation()}>
                <div className='products-modal-header'>
                    <h3>Products in Quote</h3>
                    <button className='products-modal-close' onClick={onClose}>
                        <CloseOutlined />
                    </button>
                </div>

                <div className='products-modal-content'>
                    {customerName && (
                        <div className='customer-info'>
                            Customer: <strong>{customerName}</strong>
                        </div>
                    )}

                    {products && products.length > 0 ? (
                        <Table
                            columns={columns}
                            dataSource={products}
                            pagination={false}
                            size='small'
                            rowKey={(record, index) => record._id || `product-${index}`}
                            className='products-table'
                        />
                    ) : (
                        <div className='no-products'>No products found in this quotation</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductsModal;
